const asset = (path) => `${process.env.PUBLIC_URL}/${path}`;

const theme = {
  marketplace: {
    id: "marketplace",
    name: "Marketplace Purple",
    colors: {
      background: "#fbfaff",
      surface: "#ffffff",
      surfaceAlt: "#f4efff",
      text: "#111118",
      muted: "#676575",
      primary: "#6338d6",
      primaryDark: "#3d1aa0",
      secondary: "#2fbf71",
      accent: "#f04d37",
      border: "#e6e2f1",
    },
    gradients: {
      hero: "linear-gradient(135deg, #4d16c9 0%, #7b3ff2 100%)",
      page: "linear-gradient(180deg, #ffffff 0%, #fbfaff 42%, #ffffff 100%)",
    },
    radius: {
      sm: "8px",
      md: "16px",
      lg: "24px",
    },
  },
  grocery: {
    id: "grocery",
    name: "Grocery Theme",
    colors: {
      background: "#f7fbf5",
      surface: "#ffffff",
      surfaceAlt: "#eef8ea",
      text: "#132015",
      muted: "#647063",
      primary: "#25883a",
      primaryDark: "#145826",
      secondary: "#7ac943",
      accent: "#ffb129",
      border: "#dfeadc",
    },
    gradients: {
      hero: "linear-gradient(135deg, #147433 0%, #2da34b 100%)",
      page: "linear-gradient(180deg, #ffffff 0%, #f7fbf5 100%)",
    },
    radius: { sm: "8px", md: "14px", lg: "22px" },
  },
  food: {
    id: "food",
    name: "Food Theme",
    colors: {
      background: "#fff8f2",
      surface: "#ffffff",
      surfaceAlt: "#fff0df",
      text: "#251408",
      muted: "#7b6b62",
      primary: "#f15a16",
      primaryDark: "#c64205",
      secondary: "#ffb13d",
      accent: "#df2f18",
      border: "#f2ddca",
    },
    gradients: {
      hero: "linear-gradient(135deg, #ff4f0a 0%, #ff8a1c 100%)",
      page: "linear-gradient(180deg, #ffffff 0%, #fff8f2 100%)",
    },
    radius: { sm: "8px", md: "14px", lg: "22px" },
  },
  handyman: {
    id: "handyman",
    name: "Handyman Theme",
    colors: {
      background: "#f4f8ff",
      surface: "#ffffff",
      surfaceAlt: "#edf5ff",
      text: "#101d33",
      muted: "#647084",
      primary: "#1764d8",
      primaryDark: "#0e4397",
      secondary: "#65a8ff",
      accent: "#f5a524",
      border: "#dce8f8",
    },
    gradients: {
      hero: "linear-gradient(135deg, #1558c8 0%, #2f8cff 100%)",
      page: "linear-gradient(180deg, #ffffff 0%, #f4f8ff 100%)",
    },
    radius: { sm: "8px", md: "14px", lg: "22px" },
  },
  electronics: {
    id: "electronics",
    name: "Electronics Theme",
    colors: {
      background: "#eef3fb",
      surface: "#ffffff",
      surfaceAlt: "#edf3ff",
      text: "#061330",
      muted: "#667187",
      primary: "#062169",
      primaryDark: "#03133e",
      secondary: "#2e7df6",
      accent: "#8cb6ff",
      border: "#dbe5f5",
    },
    gradients: {
      hero: "linear-gradient(135deg, #07123a 0%, #0b2d78 100%)",
      page: "linear-gradient(180deg, #ffffff 0%, #eef3fb 100%)",
    },
    radius: { sm: "8px", md: "14px", lg: "22px" },
  },
};

export const dynamicUiConfigResponse = {
  result: true,
  message: "UI configuration loaded",
  data: {
    ui_config: {
      version: "2026.08.06",
      default_theme_id: "marketplace",
      themes: theme,
      screens: {
        home: {
          screen_key: "home",
          theme_id: "marketplace",
          header: {
            locationTitle: "Deliver to",
            locationSubtitle: "4th Floor, Tech Park, Indore",
            searchPlaceholder: "Search for services, products or stores",
            notificationBadge: 3,
            avatar: asset("assets/images/thumbs/comment-img1.png"),
            actions: [
              { id: "orders", label: "Orders", icon: "Package", action: { type: "NAVIGATE", path: "/orders" } },
              { id: "cart", label: "Cart", icon: "ShoppingCart", action: { type: "NAVIGATE", path: "/cart" } },
            ],
          },
          sections: [
            {
              id: "hero_deals",
              componentType: "hero_carousel",
              layout: { mobile: 1, tablet: 1, laptop: 1, desktop: 1 },
              data: [
                {
                  eyebrow: "Mega savings",
                  title: "Great Deals Delivered Fast!",
                  subtitle: "Save more on every order",
                  image: asset("assets/images/auth/generated/auth-fruit-footer-crop.png"),
                  badge: "UP TO 60% OFF",
                  primaryAction: { label: "Shop Now", action: { type: "NAVIGATE", path: "/stores" } },
                },
              ],
            },
            {
              id: "quick_services",
              componentType: "service_grid",
              title: "Quick Services",
              action: { label: "View All", action: { type: "NAVIGATE", path: "/stores" } },
              layout: { mobile: 4, tablet: 4, laptop: 8, desktop: 8 },
              data: [
                { id: "grocery", label: "Grocery", theme_id: "grocery", icon: "ShoppingBag", bg: "#f0f8e9", action: { type: "APPLY_THEME", theme_id: "grocery" } },
                { id: "food", label: "Food", theme_id: "food", icon: "Utensils", bg: "#fff2e5", action: { type: "APPLY_THEME", theme_id: "food" } },
                { id: "pharmacy", label: "Pharmacy", icon: "Pill", bg: "#ecfbf2", action: { type: "NAVIGATE", path: "/stores" } },
                { id: "handyman", label: "Handyman", theme_id: "handyman", icon: "Wrench", bg: "#eef5ff", action: { type: "APPLY_THEME", theme_id: "handyman" } },
                { id: "taxi", label: "Taxi", icon: "CarTaxiFront", bg: "#fff7dc", action: { type: "NAVIGATE", path: "/stores" } },
                { id: "water", label: "Water", icon: "Droplets", bg: "#eefaff", action: { type: "NAVIGATE", path: "/stores" } },
                { id: "flowers", label: "Flowers", icon: "Flower2", bg: "#fff0f7", action: { type: "NAVIGATE", path: "/stores" } },
                { id: "electronics", label: "Electronics", theme_id: "electronics", icon: "Smartphone", bg: "#f1f2ff", action: { type: "APPLY_THEME", theme_id: "electronics" } },
              ],
            },
            {
              id: "exclusive_offers",
              componentType: "offer_cards",
              title: "Exclusive Offers",
              action: { label: "View All", action: { type: "NAVIGATE", path: "/shop" } },
              data: [
                { id: "offer-grocery", label: "Grocery", title: "Flat 50% OFF", subtitle: "On Fruits & Vegetables", theme_id: "grocery", image: asset("assets/images/thumbs/banner-img1.png"), action: { type: "APPLY_THEME", theme_id: "grocery" } },
                { id: "offer-food", label: "Food", title: "40% OFF", subtitle: "On your first food order", theme_id: "food", image: asset("assets/images/thumbs/banner-three-img2.png"), action: { type: "APPLY_THEME", theme_id: "food" } },
                { id: "offer-pharmacy", label: "Pharmacy", title: "20% OFF", subtitle: "On medicines & healthcare", theme_id: "marketplace", image: asset("assets/images/thumbs/product-img5.png"), action: { type: "NAVIGATE", path: "/stores" } },
              ],
            },
            {
              id: "recently_used",
              componentType: "recent_rail",
              title: "Recently Used",
              data: [
                { id: "r1", title: "Fresh Vegetables", subtitle: "Bhopal Mart", meta: "10 mins ago", image: asset("assets/images/thumbs/banner-img1.png"), action: { type: "NAVIGATE", path: "/stores" } },
                { id: "r2", title: "Chicken Biryani", subtitle: "Spice Hub", meta: "1 day ago", image: asset("assets/images/thumbs/banner-three-img2.png"), action: { type: "APPLY_THEME", theme_id: "food" } },
                { id: "r3", title: "Paracetamol 650", subtitle: "Medi Store", meta: "2 days ago", image: asset("assets/images/thumbs/product-two-img8.png"), action: { type: "NAVIGATE", path: "/stores" } },
                { id: "r4", title: "Electrician", subtitle: "Apna Service", meta: "3 days ago", image: asset("assets/images/thumbs/vendor-img4.png"), action: { type: "APPLY_THEME", theme_id: "handyman" } },
              ],
            },
            {
              id: "popular_near_you",
              componentType: "store_rail",
              title: "Popular Near You",
              action: { label: "View All", action: { type: "NAVIGATE", path: "/stores" } },
              data: [
                { id: "s1", title: "Bhopal Mart", subtitle: "Grocery Store", rating: "4.6", eta: "10 mins", image: asset("assets/images/thumbs/banner-img1.png"), action: { type: "APPLY_THEME", theme_id: "grocery" } },
                { id: "s2", title: "Spice Hub", subtitle: "Food Restaurant", rating: "4.4", eta: "15 mins", image: asset("assets/images/thumbs/banner-three-img2.png"), action: { type: "APPLY_THEME", theme_id: "food" } },
                { id: "s3", title: "Medi Store", subtitle: "Pharmacy", rating: "4.7", eta: "10 mins", image: asset("assets/images/thumbs/product-img5.png"), action: { type: "NAVIGATE", path: "/stores" } },
                { id: "s4", title: "QuickFix", subtitle: "Handyman", rating: "4.5", eta: "20 mins", image: asset("assets/images/thumbs/vendor-img4.png"), action: { type: "APPLY_THEME", theme_id: "handyman" } },
                { id: "s5", title: "Electro World", subtitle: "Electronics", rating: "4.6", eta: "30 mins", image: asset("assets/images/thumbs/product-img19.png"), action: { type: "APPLY_THEME", theme_id: "electronics" } },
              ],
            },
            {
              id: "trust_strip",
              componentType: "trust_strip",
              data: [
                { id: "delivery", icon: "Truck", title: "Free Delivery", subtitle: "On orders above Rs 99" },
                { id: "fast", icon: "Timer", title: "Fast Delivery", subtitle: "10-20 mins" },
                { id: "quality", icon: "ShieldCheck", title: "Best Quality", subtitle: "100% Original" },
                { id: "returns", icon: "BadgeCheck", title: "Easy Returns", subtitle: "Hassle Free" },
              ],
            },
          ],
          bottomNav: [
            { id: "home", label: "Home", icon: "Home", active: true, action: { type: "NAVIGATE", path: "/home" } },
            { id: "services", label: "Services", icon: "Grid3X3", action: { type: "NAVIGATE", path: "/stores" } },
            { id: "offers", label: "Offers", icon: "BadgePercent", raised: true, action: { type: "NAVIGATE", path: "/shop" } },
            { id: "orders", label: "Orders", icon: "ShoppingBag", action: { type: "NAVIGATE", path: "/orders" } },
            { id: "account", label: "Account", icon: "UserRound", action: { type: "NAVIGATE", path: "/my-account" } },
          ],
        },
        login: {
          screen_key: "login",
          theme_id: "marketplace",
          backgroundColor: "#ffffff",
          inputBackgroundColor: "#ffffff",
          buttonColor: "#42489b",
          buttonTextColor: "#ffffff",
          linkColor: "#24ca74",
          footerImage: asset("assets/images/auth/generated/auth-fruit-footer-crop.png"),
        },
        signup: {
          screen_key: "signup",
          theme_id: "marketplace",
          backgroundColor: "#ffffff",
          inputBackgroundColor: "#ffffff",
          buttonColor: "#42489b",
          buttonTextColor: "#ffffff",
          linkColor: "#24ca74",
          footerImage: asset("assets/images/auth/generated/auth-fruit-footer-crop.png"),
        },
      },
    },
  },
};

export default dynamicUiConfigResponse;
